module.exports = __webpack_public_path__ + "img/Scorpio.b03a399f.png";